import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-left",
  "use": "icon-chevron-left-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-chevron-left\">\n  <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M12.193 16.001l1.307-1.067L9.114 10 13.5 5.066l-1.307-1.067L6.5 10z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol